export default "__VITE_ASSET__C1ZJz3br__"